<template>
  <b-container>
    <b-row style="margin-top: 4em">
      <b-col>
        <h2 class="text-secondary">
          <i>{{ $t("globals.new_item") }}</i>
        </h2>
      </b-col>
      <b-col>
        <b-btn
          variant="success"
          style="float: right; margin-left: 0.3em"
          @click="saveItem"
          :disabled="!requiredData"
        >
          {{ $t("globals.save") }}
        </b-btn>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col>
              <span>{{ $t("globals.brand") }}:</span>
              <b-form-select
                v-model="item.brand"
                :options="getBrandOptions"
                disabled
              />
              <span>{{ $t("globals.type") }}:</span>
              <b-form-input v-model="item.item_type"></b-form-input>
              <span>{{ $t("globals.name") }}:</span>
              <b-form-input v-model="item.item_name"></b-form-input>
              <span>{{ $t("globals.fleet_size") }}:</span>
              <b-form-input v-model.number="item.fleet_size"></b-form-input>
              <span>{{ $t("globals.contract_duration") }}:</span>
              <b-form-input
                v-model.number="item.contract_duration"
              ></b-form-input>
              <span>{{ $t("globals.exact_code") }}:</span>
              <b-form-select
                v-model="item.exact_code_id"
                :options="exactCodeOptions"
              />
              <div class="row">
                <div class="col">
                  <span>{{ $t("globals.is_device") }}:</span>
                  <b-form-radio-group
                    v-model="item.is_device"
                    :options="isDeviceOptions"
                  />
                </div>
                <div class="col">
                  <span>{{ $t("globals.is_lease") }}:</span>
                  <b-form-radio-group
                    v-model="item.is_lease"
                    :options="isDeviceOptions"
                  />
                </div>
              </div>
            </b-col>
            <b-col>
              <span>{{ $t("globals.price_once") }}:</span>
              <b-input-group>
                <b-form-input
                  v-model.number="item.price_one_time"
                ></b-form-input>
                <b-form-input
                  :placeholder="
                    currencyFormat(
                      item.price_one_time,
                      item.currency
                    ).toString()
                  "
                  disabled
                >
                </b-form-input>
              </b-input-group>
              <span>{{ $t("globals.price_monthly") }}:</span>
              <b-input-group>
                <b-form-input
                  v-model.number="item.price_per_month"
                ></b-form-input>
                <b-form-input
                  :placeholder="
                    currencyFormat(
                      item.price_per_month,
                      item.currency
                    ).toString()
                  "
                  disabled
                >
                </b-form-input>
              </b-input-group>
              <span>{{ $t("globals.costs") }}:</span>
              <b-input-group>
                <b-form-input v-model.number="item.costs"></b-form-input>
                <b-form-input
                  :placeholder="
                    currencyFormat(item.costs, item.currency).toString()
                  "
                  disabled
                >
                </b-form-input>
              </b-input-group>
              <span>{{ $t("globals.vat") }}:</span>
              <b-form-input v-model.number="item.vat"></b-form-input>
              <span>{{ $t("globals.currency") }}:</span>
              <b-form-select
                v-model="item.currency"
                :options="getCurrencyOptions"
              />
              <span>{{ $t("globals.description") }}:</span>
              <b-form-input v-model="item.description"></b-form-input>
              <span>{{ $t("globals.kpi_type") }}:</span>
              <b-form-select
                v-model="item.kpi_type"
                :options="kpiTypeOptions"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { currencyFormat } from "@/helpers/price";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      exactCodeOptions: [],
      kpiTypeOptions: [],
      isDeviceOptions: [
        {
          text: "True",
          value: true
        },
        {
          text: "False",
          value: false
        }
      ],
      item: {
        brand: "",
        fleet_size: 0,
        contract_duration: 0,
        item_name: "",
        item_type: "",
        price_one_time: 0,
        price_per_month: 0,
        costs: 0,
        vat: 0,
        currency: "EUR",
        description: "",
        is_device: false,
        is_lease: false,
        exact_code_id: null,
        kpi_type: ""
      }
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch", "simpleMutation"]),
    ...mapActions("constants", ["fetchActiveEnums"]),
    ...mapMutations(["setShowLoadingModal"]),
    currencyFormat,
    saveItem() {
      this.edit = false;

      let data = {
        query: `
          mutation BillingItemCreateEdit($billing_item: BillingItemInput) {
            res: BillingItemCreateEdit (billing_item: $billing_item)
          }
        `,
        variables: {
          billing_item: this.item
        }
      };

      this.simpleMutation({data, this_ref: this}).then(() => {
        this.$router.push({
          name: "allitems"
        });
      });
    },
    fetchExactCodeOptions() {
      let data = {
        query: `
          query  {
            ExactCodes {
              value: id
              text: description
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.exactCodeOptions = res.ExactCodes;
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    },
    callFetchEnums() {
      this.fetchActiveEnums({this_ref: this, enums: ["kpi_type"]})
        .then((res) => {
          if (res) {
            this.kpiTypeOptions = res.kpi_type;
          }
        })
    },
  },
  computed: {
    ...mapGetters("constants", [
      "getBrandOptions",
      "getCurrencyOptions"
    ]),
    ...mapGetters(["getUserSystem"]),
    requiredData() {
      return (
        this.item.item_type.length > 0 &&
        this.item.item_name.length > 0 &&
        this.item.fleet_size >= 0 &&
        this.item.currency.length > 0 &&
        this.item.contract_duration >= 0 &&
        this.item.price_one_time >= 0 &&
        this.item.price_per_month >= 0 &&
        this.item.costs >= 0 &&
        this.item.vat >= 0 &&
        this.item.exact_code_id != null
      );
    }
  },
  mounted() {
    this.item.brand = this.getUserSystem.toLowerCase();
    this.callFetchEnums();
    this.fetchExactCodeOptions();
  }
};
</script>
